import { useTexts } from 'utils/useTexts';
import { useFormContext } from '@context/FormContext';
import { Screens } from '@shared/constants/screens';
import { toDefaultPhoneFormat } from 'utils/stringFormat';
import { useAnalytics } from '@shared/hooks/useAnalytics';
import { SEGMENT_SCREEN_PARAMS } from '@shared/constants/segmentConstants';

const IdentityFailedPage = () => {
  const { t } = useTexts();
  const { trackClick } = useAnalytics(SEGMENT_SCREEN_PARAMS.PROVE_IDENTITY,false);
  const { verifyYourIdentity, handleStep } = useFormContext();


  const handleClickHere = () => {
    localStorage.clear();
    window.location.reload();
    handleStep(Screens.ENTER_LICENSE_PLATE);
  };

  const handlePhoneNumberClick = () => {
    trackClick('CTA Clicked', {
      cta_text: 'Call'+t('contactPhoneNumber'),
      cta_type: 'phone',
      cta_context: 'off-ramp',
      interaction_type: 'cta_click',
      destination_url: 'tel:'+t('contactPhoneNumber'),
      value: 75,
      currency: 'USD',
    });
  };

  return (
    <div>
      <div className="iLendingCDX-identity-failed">
        <h1> {t('identityFailed.title')}</h1>
        <p>{t('identityFailed.unableToVerify')}</p>

        <p className="iLendingCDX-user-phone">{toDefaultPhoneFormat(verifyYourIdentity?.phone) ?? ''}</p>
        <p className="iLendingCDX-click-to-restart">
          {t('identityFailed.restartText1')}{' '}
          <a
            className="iLendingCDX-click-here"
            onClick={handleClickHere}
          >
            {t('identityFailed.clickHere')}
          </a>{' '}
          {t('identityFailed.restartText2')}
        </p>

        <p>
          {t('identityFailed.continueApplication')}{' '}
          <a
            className="iLendingCDX-contact-number"
            href={'tel:' + t('contactPhoneNumber').replace(/-/g, '')}
            onClick={handlePhoneNumberClick}
          >
            {t('contactPhoneNumber')}
          </a>
        </p>
      </div>
    </div>
  );
};

export default IdentityFailedPage;
